(function () {
    $(window).on('load', function (e) {
        if (window.location.hash === '#citation') {
            $('.tab__citation-search a').click();
        }
    });
})();
